import React from 'react';

interface ISingleResultRow {
  hit: any;
  setShowFullRecord: any;
  showFilters: boolean;
}

const EntityRow: React.FC<ISingleResultRow> = ({
  showFilters,
  hit,
  setShowFullRecord,
}) => {
  const handleShowFullRecord = (fullHit: any) => {
    setShowFullRecord({ show: true, record: fullHit });
  };

  return (
    <div
      className='screening-results-row'
      onClick={() => handleShowFullRecord(hit)}
    >
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-link-cell-text'>
            {hit?._source['Name of Entity']}
          </div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            {hit?._source['Entity Country']}
          </div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            {hit?._source['List Name']}
          </div>
        </div>
      </div>
      {!showFilters && (
        <>
          <div className='screening-results-row-default-cell'>
            <div className='screening-results-row-default-cell-inner'>
              <div className='screening-results-row-default-cell-text'>
                {hit?._source.Agency}
              </div>
            </div>
          </div>
          <div className='screening-results-row-default-cell'>
            <div className='screening-results-row-default-cell-inner'>
              <div className='screening-results-row-default-cell-text'>
                {hit?._source['Additional Remarks']}
              </div>
            </div>
          </div>
          <div className='screening-results-row-default-cell'>
            <div className='screening-results-row-default-cell-inner'>
              <div className='screening-results-row-default-cell-text'>
                {hit?._source['Date Updated on BITE Platform']}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EntityRow;
